import React from "react";
import {
  Alert,
  AlertDescription,
} from "../../../../../components/ui/AlertDetailedReport";

interface InfoListProps {
  items: string[];
  title?: string;
  className?: string;
  numbered?: boolean;
  withAlert?: boolean;
}

const InfoList = ({
  items,
  title,
  className = "",
  numbered = false,
  withAlert = true,
}: InfoListProps) => {
  const ListContent = () => (
    // <ul className={`${numbered ? "list-decimal" : "list-disc"} pl-5 space-y-1`}>
    <ul className="list-none text-base pl-0 space-y-1">
      {items.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  );

  const content = (
    <>
      {title && <h4 className="font-medium  ">{title}</h4>}
      {withAlert ? (
        <Alert className="border-0 shadow-none ">
          <AlertDescription className="mt-0 mb-0">
            <ListContent />
          </AlertDescription>
        </Alert>
      ) : (
        <ListContent />
      )}
    </>
  );

  return <div className={` ${className}`}>{content}</div>;
};

export default InfoList;
